// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--pt1tH";
export var c_banner = "styles-module--c_banner--Phh57";
export var link = "styles-module--link--soKKd";
export var title = "styles-module--title--yXtTJ";
export var wrapper = "styles-module--wrapper--o7msZ";